import { memo, useState } from "react";
import "./templateStyles.css";
import { Input } from "antd";
import Search from "../../../assets/icons/Search.svg";
import { TranslatedConstants } from "../../../utilities/Constants/TranslateConstants";
import { useTranslation } from "react-i18next";
import { useTemplateTypeContext } from "../../../context/workbench/TemplateTypeContext";
import { usePermission } from "../../../hooks/usePermission";

const TemplateCard = ({ template, onDragStart }: any) => (
  <div className="col-md-6">
    <div
      className="card template-card"
      onDragStart={(event) => onDragStart(event, template.type)}
      draggable
    >
      <div className="card-body">
        <img src={template.icon} alt={template.name} />
      </div>
    </div>
    <p className="template-name mb-0">{template.name}</p>
  </div>
);

const Templates = () => {
  const { t } = useTranslation("common");
  const context = useTemplateTypeContext();
  
  const [sidebarOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState<any>('');
  const { templateData } = TranslatedConstants();

  const { canView, canEdit } = usePermission();
  const templatesClass = canView && !canEdit ? "d-none" : "";

  const onDragStart = (event: any, nodeType: any) => {
    context.changeType(nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  const filteredTemplates = templateData?.filter((template) =>
    template?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  return (
    <>
      <div className={`templates ${sidebarOpen ? "open" : "close"} ${templatesClass}`}>
        <div className="d-flex flex-row justify-content-between align-items-center mt-2">
          <p className="mb-0 title">{t('templates')}</p>
          {/* <Button
            className={`right-sidebar-handle p-0 bg-transparent ${sidebarOpen ? "open" : "close"}`}
            onClick={handleSidebarOpenClose}
          >
            <img width={28} src={sideBarHide} alt="sidebar toggle" />
          </Button> */}
        </div>
        
        <Input
          size="large"
          type="search"
          placeholder={t('templatesSearchPlaceholder')}
          prefix={<img src={Search} alt="search" className="search-icon"/>}
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="template-section">
          <div className="row g-3">
            {filteredTemplates?.map((template:any) => (
              <TemplateCard
                key={template.id}
                template={template}
                onDragStart={onDragStart}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(Templates);
